import { put, takeLatest } from "redux-saga/effects";
import axiosCustom from "common/components/apiConfig";
import {
    handleNotificationAlertCatch,
    handleNotificationAlertTrySelect
} from "common/method/handleNotificationAlert";

export const actionTypes = {
    selectOptionsMarketWatch: "[selectOptionsMarketWatch] Action",
    selectOptionsMarketWatchLoading: "[selectOptionsMarketWatchLoading] Action",
    selectOptionsMarketWatchAsync: "[selectOptionsMarketWatchAsync] Action"
};

const initialState = {
    data: [],
    size: 10,
    total: 0,
    loading: false
};

export const Options_market_watch_select_reducer = (
    state = initialState,
    { type, payload }
) => {
    switch (type) {
        case actionTypes.selectOptionsMarketWatch:
            return {
                ...state,
                data: payload.results,
                total: payload.total
                    ? payload.total > 10000
                        ? 10000
                        : payload.total
                    : 0
            };
        case actionTypes.selectOptionsMarketWatchLoading:
            return {
                ...state,
                loading: payload
            };
        default:
            return state;
    }
};


function* handleWorker({ payload }) {
    yield put({ type: actionTypes.selectOptionsMarketWatchLoading, payload: true });

    let config = {
        url: "select_request"
    };

    let data = {
        table: "option",
        method_type: "select_options_market_watch",
        data: payload?.data ? payload?.data : {},
        from: payload.from ? (payload.from - 1) * payload.size : 0,
        size: payload.size,
        sort_by: payload.sort_by
    };

    try {
        let res = yield axiosCustom(config, data);

        let isOk = handleNotificationAlertTrySelect(res);
        if (!isOk) return;

        yield put({
            type: actionTypes.selectOptionsMarketWatch,
            payload: res.data.response.data
        });
    } catch {
        handleNotificationAlertCatch();
    } finally {
        yield put({ type: actionTypes.selectOptionsMarketWatchLoading, payload: false });
    }
}

export function* SelectOptionsMarketWatch() {
    yield takeLatest(actionTypes.selectOptionsMarketWatchAsync, handleWorker);
}